import { useTranslation } from 'react-i18next';

export default function FullCTA() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Golden%20hour%20sunset%20over%20rolling%20meadow%20filled%20with%20colorful%20wildflowers%20and%20tall%20grass%2C%20vintage%20picnic%20blanket%20spread%20on%20ground%20with%20fashion%20accessories%20and%20straw%20hat%2C%20warm%20magical%20evening%20light%20casting%20long%20shadows%2C%20peaceful%20countryside%20atmosphere%2C%20dreamy%20romantic%20editorial%20photography%20with%20rich%20golden%20amber%20hues%20and%20cinematic%20lens%20flare&width=1920&height=1200&seq=cta-full-v2-2026&orientation=landscape"
          alt="Kakobuy Spreadsheet - pełny dostęp"
          title="Kakobuy Spreadsheet - pełny dostęp"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35"></div>

      <div className="relative z-10 text-center px-6">
        <h2 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-white tracking-wide uppercase">
          {t('cta.headline')}
        </h2>
        <p className="mt-4 text-base md:text-lg text-white/80 font-light">
          {t('cta.subheadline1')}
        </p>
        <p className="text-base md:text-lg text-white/80 font-light">
          {t('cta.subheadline2')}
        </p>
        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-3 mt-10 bg-primary-500 text-background-50 px-10 py-4 rounded-full text-sm md:text-base font-semibold hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer group"
        >
          <span className="w-9 h-9 rounded-full bg-accent-500 flex items-center justify-center">
            <i className="ri-shopping-bag-line text-white text-base"></i>
          </span>
          {t('cta.button')}
          <i className="ri-arrow-right-up-line text-lg group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
        </a>
      </div>
    </section>
  );
}